import { Button } from '@/shared/ui';
import MessageIcon from '@/assets/icons/message-fill-primary.svg';
import useDeviceType from '@/shared/hooks/useDeviceType';
import { useRef } from 'react';
import CallCenterWorkingHours from './call-center-working-hours';

interface IProps {
    onAction: (back?: boolean) => void;
}

const OtherTrouble = ({ onAction }: IProps) => {
    const { deviceType } = useDeviceType();
    const telLinkRef = useRef<HTMLAnchorElement | null>(null);

    return (
        <div className="flex flex-col gap-7" data-testid="other-trouble-container">
            <div className="flex flex-col items-center gap-3 md:gap-7">
                <img src={MessageIcon} alt="" />
                <div className="w-full flex flex-col items-center gap-3 md:gap-4">
                    <h4 className="font-agrandir text-2xl md:text-36" data-testid="other-trouble-title">Having Trouble?</h4>

                    <p data-testid="other-trouble-content-text" className="w-[357px] max-w-full px-5 text-center font-dmSans text-17 md:text-xl xs:px-0">
                        If you’re having trouble, give us a call at{' '}
                        {deviceType === 'mobile'
                            ? <a ref={telLinkRef} href="tel:+18002707091" data-testid="other-trouble-content-call-link" className="underline font-bold">(866) 865-6771</a>
                            : <span data-testid="other-trouble-content-call-span" className="underline font-bold">(866) 865-6771</span>}{' '}
                        to speak MedBox care advisor during operating hours:
                    </p>

                    <CallCenterWorkingHours />
                </div>
            </div>
            <div className="flex flex-col gap-2.5 md:gap-4">
                {deviceType === 'mobile' ? (
                    <Button
                        showEndIcon
                        onClick={() => { telLinkRef.current?.click(); onAction(true); }}
                        testId="button-other-trouble-call"
                        fontClassName="font-bold"
                    >
                        Give us a Call
                    </Button>
                ) : (
                    <Button
                        showEndIcon
                        onClick={() => onAction(true)}
                        testId="button-other-trouble-call-close"
                        fontClassName="font-bold"
                    >
                        Close
                    </Button>
                )}
                <Button testId="button-other-trouble-back" variant="text" onClick={() => onAction()}>
                    <span className="font-atkinsonBold">Back</span>
                </Button>
            </div>
        </div>
    );
};

export default OtherTrouble;
